/**
 * Create easing function for given transition delay
 *
 * @param {number} delay - Transition delay
 * @return {function} Easing function bound with provided delay
 */
export const createEasing =
  delay =>
  (...properties) =>
    properties.map(property => `${property} ${delay}ms ease-in-out`).join(',');

/**
 * Default easing function
 *
 * @param {string[]} properties - Properties to apply transition delay
 * @return {string} CSS transition property
 */
export const easing = createEasing(200);
